import { render, staticRenderFns } from "./kiriman.vue?vue&type=template&id=f3c81b74"
import script from "./kiriman.vue?vue&type=script&lang=js"
export * from "./kiriman.vue?vue&type=script&lang=js"
import style0 from "./kiriman.vue?vue&type=style&index=0&id=f3c81b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports